import { IComponentOptions, IFormController } from 'angular';
import { dirtyfields } from '../../tn.common';
import template from '../partials/email-popover.html';

export class EmailPopoverFormController {
    // bindings
    public heading?: string;
    public subheading?: string;
    onSendEmail?: (args: { email: string }) => void;

    // locals
    public email = '';
    public sendForm?: IFormController;

    public sendEmail(): void {
        console.log('EmailPopoverFormController.sendEmail', { ...this });
        if (!this.sendForm) {
            console.error('EmailPopoverFormController.sendForm is not defined');
            return;
        }
        if (!this.sendForm.$valid) {
            console.error('EmailPopoverFormController.sendForm is not valid');
            dirtyfields(this.sendForm);
            return;
        }

        if (!this.email) {
            console.error('EmailPopoverFormController.email is not defined');
            dirtyfields(this.sendForm);
            return;
        }

        if (!this.onSendEmail) {
            console.warn(
                'EmailPopoverFormController.onSendEmail is not defined'
            );
            return;
        }

        this.onSendEmail && this.onSendEmail({ email: this.email });
        // reset email. TODO: consider letting this be reset by parent
        this.email = '';
        this.sendForm.$setPristine(); // reset form
    }
}

export const EmailPopoverFormComponent: IComponentOptions = {
    bindings: {
        heading: '<',
        subheading: '<',
        onSendEmail: '&',
    },
    controller: EmailPopoverFormController,
    controllerAs: 'popover',
    template,
};
